import { atom } from "recoil";
import { recoilPersist } from "./recoil-persist/dist";

const { persistAtom } = recoilPersist({
  key: "recoil-persist", // this key is using to store data in local storage
  storage: localStorage, // configurate which stroage will be used to store the data
});

export const titleState = atom({
  key: "titleState",
  default: "ข่าวสาร",
});

export const counterState = atom({
  key: "count",
  default: 0,
  effects_UNSTABLE: [persistAtom],
});

export const tokenState = atom({
  key: "tokenState",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const univer = atom({
  key: "univer",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const userState = atom({
  key: "user",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const Jobstate = atom({
  key: "Jobs",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const healstate = atom({
  key: "heal",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const NotificationState = atom({
  key: "Notification",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const Order = atom({
  key: "Order",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const Type = atom({
  key: "Type",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
